import {ref} from 'vue';
import store from '@/store';

export const MonitorLoggingEvent = {
    //Browser events
    CURSOR_LOST: 'cur',
    FOCUS_LOST: 'foc',
    TAB_LOST: 'tab',
    FULL_SCREEN_LOST: 'fsc',
    BROWSER_RESTORE: 'brw_r', // Browser Restore from cursor, focus, tab fullscreen lost


    // Camera events
    CAMERA_LOST: 'cam_l',
    CAMERA_RESTORE: 'cam_r', // Camera restore from camera lost

    FACE_LOST: 'fac_l',
    MULTIPLE_FACE_DETECT: 'mfac_d',
    FACE_RESTORE: 'fac_r', // face restore from face lost and multiple face detect

    STATIC_PHOTO_UPLOAD_FAIL: 's_photo_f',
    NO_FACE_PHOTO_UPLOAD_FAIL: 'nf_photo_f',
    MULTIPLE_FACE_PHOTO_UPLOAD_FAIL: 'mf_photo_f',
    COMPLETE_PHOTO_UPLOAD_FAIL: 'c_photo_f'
};

const browserEventTypes = [
    MonitorLoggingEvent.CURSOR_LOST,
    MonitorLoggingEvent.FOCUS_LOST,
    MonitorLoggingEvent.TAB_LOST,
    MonitorLoggingEvent.FULL_SCREEN_LOST,
    MonitorLoggingEvent.BROWSER_RESTORE
];

const cameraEventTypes = [
    MonitorLoggingEvent.CAMERA_LOST,
    MonitorLoggingEvent.CAMERA_RESTORE,

];

const faceAnomalyEventType = [
    MonitorLoggingEvent.FACE_RESTORE,
    MonitorLoggingEvent.FACE_LOST,
    MonitorLoggingEvent.MULTIPLE_FACE_DETECT,
]

/**
 * Shared global state.
 */
const lastEvent = ref();

/**
 * Coordinates logging of browser and camera events.
 */
export function useMonitorLogging() {
    async function submitEvent(event) {
        try {
            let response = await store.dispatch('Monitoring/submitEvent', event);
            return response;
        } catch (error) {
        }
    }

    async function logEvent(type) {
        const event = {
            type: type,
            isLostEvent: function () {
                let lost_type_event = [
                    MonitorLoggingEvent.CURSOR_LOST,
                    MonitorLoggingEvent.FOCUS_LOST,
                    MonitorLoggingEvent.TAB_LOST,
                    MonitorLoggingEvent.FULL_SCREEN_LOST,
                    MonitorLoggingEvent.CAMERA_LOST,
                    MonitorLoggingEvent.FACE_LOST,
                    MonitorLoggingEvent.MULTIPLE_FACE_DETECT]
                return lost_type_event.includes(type)
            },

            isBrowserEvent: function () {
                return browserEventTypes.includes(type);
            },

            isCameraEvent: function () {
                return cameraEventTypes.includes(type);
            },

            isFaceAnomalyEvent: function () {
                return faceAnomalyEventType.includes(type);
            }
        };

        lastEvent.value = event;
        let response = await submitEvent(event);
        return response
    }

    async function logPhotoUploadFailed(test_state, photo_anomaly_event_log_type = null) {
        let type = '';
        switch (test_state) {
            case 'in-progress':
                if (photo_anomaly_event_log_type === null) {
                    type = MonitorLoggingEvent.STATIC_PHOTO_UPLOAD_FAIL;
                }else if(photo_anomaly_event_log_type==MonitorLoggingEvent.FACE_LOST) {
                    // no face detected or multiple face detected
                    type = MonitorLoggingEvent.NO_FACE_PHOTO_UPLOAD_FAIL;
                }else if(photo_anomaly_event_log_type==MonitorLoggingEvent.MULTIPLE_FACE_DETECT) {
                    // no face detected or multiple face detected
                    type = MonitorLoggingEvent.MULTIPLE_FACE_PHOTO_UPLOAD_FAIL;
                }
                break;
            case 'complete':
                type = MonitorLoggingEvent.COMPLETE_PHOTO_UPLOAD_FAIL;
                break;
        }
        return await logEvent(type);
    }

    async function logCursorLost() {
        return await logEvent(MonitorLoggingEvent.CURSOR_LOST);
    }

    async function logFocusLost() {
        return await logEvent(MonitorLoggingEvent.FOCUS_LOST);
    }


    async function logTabLost() {
        return await logEvent(MonitorLoggingEvent.TAB_LOST);
    }


    async function logFullScreenLost() {
        return await logEvent(MonitorLoggingEvent.FULL_SCREEN_LOST);
    }


    async function logCameraLost() {
        return await logEvent(MonitorLoggingEvent.CAMERA_LOST);
    }

    async function logNoFaceDetected() {
        let event_id = await logEvent(MonitorLoggingEvent.FACE_LOST)
        return event_id;
    }

    async function logMultipleFaceDetected() {
        let event_id = await logEvent(MonitorLoggingEvent.MULTIPLE_FACE_DETECT)
        return event_id;
    }

    async function logRestoreBrowser() {
        return await logEvent(MonitorLoggingEvent.BROWSER_RESTORE);
    }

    async function logRestoreFace() {
        return await logEvent(MonitorLoggingEvent.FACE_RESTORE);
    }

    async function logCameraRestore() {
        return await logEvent(MonitorLoggingEvent.CAMERA_RESTORE);
    }

    async function closeLostEventAfterHalting() {

        // if we have lost event exists
        if (lastEvent.value != null && lastEvent.value.isLostEvent()) {

            // if last event is browser event, then log restore browser
            if (lastEvent.value.isBrowserEvent()) {
                await logRestoreBrowser();

                // if last event is face anomaly event, then we log restore face event
            } else if (lastEvent.value.isFaceAnomalyEvent()) {
                await logRestoreFace();

                // although camera disconnected will not be recorded here, but put it here as safe-bet
            } else if (lastEvent.value.isCameraEvent()) {
                await logCameraRestore();
            }
        }
        return Promise.resolve(null);
    }

    return {
        logCursorLost,
        logFocusLost,
        logTabLost,
        logFullScreenLost,
        logCameraLost,
        logCameraRestore,
        logNoFaceDetected,
        logMultipleFaceDetected,
        logRestoreFace,
        closeLostEventAfterHalting,
        logPhotoUploadFailed,
    }
}
